
import { Component, ElementRef, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import Chart from 'chart.js/auto';

import axios from "src/app/Service/axios";

import { Location } from '@angular/common';

import Map from 'ol/Map';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions,

} from 'ol/interaction';


import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";

import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import { Tile } from "ol/layer";

import { MapService } from "src/app/Service/map.service";

import { DeviceDetectorService } from "ngx-device-detector";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";

import "ol/ol.css";

import * as XLSX from 'xlsx';

import zoomPlugin from 'chartjs-plugin-zoom';

import { getRelativePosition } from 'chart.js/helpers';

import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from "@angular/forms";

import { DataService } from "src/app/Service/data.service";

import { Observable, map, startWith } from "rxjs";

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import { animate, state, style, transition, trigger } from '@angular/animations';

import { GurdServiceService } from "src/app/Service/gurd-service.service";

declare let $: any;

@Component({

  selector: 'app-search-student',

  templateUrl: './search-student.component.html',

  styleUrls: ['./search-student.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class SearchStudentComponent implements OnInit {

  list_Schools = [];

  list_Students: any = [];

  list_search = [];

  list_Finance: any = [];

  list_search2: any = [];

  studentData: any;

  source: any;

  source2: any;

  vector: any;

  vector2: any;

  layers: any = [];

  layers2: any = [];

  myControl = new FormControl();

  filteredOptions!: Observable<string[]>

  map: any;

  map2: any;

  location_MIN_MAX: any;

  filteredSchools = [];

  lst_Credit = [];

  searchT_School = '';

  iMobileDomain: string = '-1';

  lstPassenger: any = [];

  isLoading: boolean = false;

  bAbsence: boolean = false;

  bEdit_Std: boolean = false;

  bAction_Std: boolean = false;

  bFinancial_Std: boolean = false;

  bFinancial_Edit: boolean = false;

  bFinancial_Delete: boolean = false;

  bAddFinancial: boolean = false;

  editMode: boolean = false;

  bDataLoaded: boolean = false;

  bPersonnel: boolean = false;

  showCustom_Map: boolean = false;

  showFilter: boolean = false;

  std_PhoneNumber!: string | undefined;

  userActivity: [] = [];

  list_Absence: [] = [];

  lst_UserManager = [];

  list_Grade: [] = [];

  list_Class: [] = [];

  lst_Result: any = [];

  financialModel: any = {};

  iTotalOwed: number = 0;

  iTotalCreditor: number = 0;

  baseLocation: any = [51.3833554, 35.6770113];

  tiAvatarStatus: number = -1;

  iAmount: number = 0;

  clickedItem: any = {};

  date: FormGroup = this.FormBuilder.group({

    strDate: new FormControl('')

  })

  mdl_Personnel: FormGroup = this.FormBuilder.group({

    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    strName: new FormControl('', Validators.required),

    strFamily: new FormControl('', Validators.required),

    strMobile: new FormControl('', Validators.required),

    tiSex: new FormControl('-1', Validators.required),

    strNationalCode: new FormControl(''),

    fOrigiLat: new FormControl('0'),

    fOriginLon: new FormControl('0'),

    strAddress: new FormControl(''),

    strChart: new FormControl('', Validators.required),

    iMobileDomain: new FormControl('-1', this.OtherService.zeroOrMoreValidator()),

    iPassenger: new FormControl(''),

    strSTime: new FormControl(''),

    strETime: new FormControl(''),

    bActive: new FormControl(false),

    itemIndex: new FormControl('-1'),

    strExpireDate: new FormControl(''),

    strRFIDCodes: new FormControl(''),

  })

  mdl_Search: FormGroup = this.FormBuilder.group({

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strMobile: new FormControl('', Validators.required),

    iPassenger: new FormControl(''),

  });

  mdl_ReportDaily: FormGroup = this.FormBuilder.group({

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strImage: new FormControl(''),

    strComment: new FormControl('', Validators.required),

    iPassenger: new FormControl('', Validators.required),

  });

  mdl_Charge: FormGroup = this.FormBuilder.group({

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    iPassenger: new FormControl('', Validators.required),

    iAmount: new FormControl('', Validators.required),

    current_iAmount: new FormControl(''),

    strPassenger_FullName: new FormControl(''),

    strTrackingCode: new FormControl(''),

  });

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  acssess: any;

  obj_Std: any = {};

  constructor(

    private location: Location,

    private Notification: NotificationService,

    private mapService: MapService,

    private FormBuilder: FormBuilder,

    private gurdService: GurdServiceService,

    private route: ActivatedRoute,

    private router: Router,

    private OtherService: OtherService


  ) { }

  ngOnInit(): void {

    this.route.url.subscribe((segment) => {

      if (segment[0].path == 'search-personnel') {

        $('.clockpicker').clockpicker({

          donetext: 'top',

          align: 'top',

          autoclose: true,

        });

        this.bPersonnel = true;


      }

      this.getSchools();

      var data = window.localStorage.getItem("menu") as any;

      this.acssess = JSON.parse(this.gurdService.decrypt(data));

      this.bAbsence = this.accessibility('bSchoolService_PresenceAbsence');

      this.bEdit_Std = this.accessibility('bSchoolService_Student_Save');

      this.bAction_Std = this.accessibility('bSchoolService_PassengerActions');

      this.bFinancial_Std = this.accessibility('bSchool_School_Financial');

      this.bFinancial_Edit = this.accessibility('bSchool_School_Financial_Edit');

      this.bFinancial_Delete = this.accessibility('bSchool_School_Financial_Delete');

    })

  }

  filterSchool() {

    if (this.searchT_School == '') {

      this.filteredSchools = [];

      this.iMobileDomain = '-1';

    }

    else this.filteredSchools = this.list_Schools.filter((item: any) => item.strComment.includes(this.searchT_School));
  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.list_Students = this.list_search.filter((el: any) => {

        return el?.strName.includes(search) ||

          el?.strFamily.includes(search) ||

          (el?.strMobileDomain_strComment && el?.strMobileDomain_strComment.includes(search)) ||

          el?.strGrade.includes(search) ||

          el?.strClassNo_strTitle.includes(search) ||

          el?.strEducationDistrict_strComment.includes(search) ||

          el?.strEducationLevel_strComment.includes(search) ||

          el?.strSchoolType_strComment.includes(search) ||

          el?.strGender.includes(search) ||

          el?.strFullName.includes(search) ||

          el?.strAddress.includes(search)

      })

    }

    else if (search == '') this.list_Students = this.list_search
  }

  goBack() {

    this.location.back();
  }

  async getSchools() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    this.OtherService.Showspinner()

    let res = JSON.parse((await axios.post(`School_User_List`, model)).data.toString());

    this.OtherService.nonespinner()

    this.list_Schools = res;

    // /------------------------------------------------------------------

    if (this.bPersonnel) {

      this.OtherService.Showspinner()

      let res_3 = JSON.parse((await axios.post(`UserManager_Chart_List`, {})).data.toString());

      this.lst_UserManager = res_3;

      this.OtherService.nonespinner();


    }

    // /------------------------------------------------------------------

    let res_1 = JSON.parse((await axios.post(`Grade_List`, model)).data.toString());

    this.list_Grade = res_1;

    // /------------------------------------------------------------------

    let res_2 = JSON.parse((await axios.post(`ClassNo_List`, {})).data.toString())

    this.list_Class = res_2;


  }

  async searchStudent(form: NgForm) {

    this.isLoading = true;

    var model = this.OtherService.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strMobile: form.value.strMobile != '' ? form.value.strMobile : '',

      strFullName: form.value.strFullName != '' ? form.value.strFullName : '',

      strNationalCode: form.value.strNationalCode != '' ? form.value.strNationalCode : '',

      tiSex: form.value.tiSex != '' ? form.value.tiSex : -1,

      tiGrade: form.value.tiGrade,

      tiClassNo: form.value.tiClassNo,

      tiAvatarStatus: form.value.tiAvatarStatus,

      iMobileDomain: this.iMobileDomain || -1

    })

    const METHOD = this.bPersonnel ? 'Passenger_List' : 'School_Passenger_List';

    let res = JSON.parse((await axios.post(METHOD, model)).data.toString());

    this.isLoading = false;

    if (res.iResult == 0) return this.Notification.showError(res.strError)

    this.list_Students = res;

    this.list_search = res;

    if (res.length == 0) return this.Notification.showError('موردی یافت نشد')


  }

  exportExcel(id?: string) {

    setTimeout(() => {

      let element = document.getElementById(id ? id : 'Export_Excel');

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, id ? 'لیست گزارشات.xlsx' : 'دانش آموزان.xlsx');

    }, 200);

  }

  showOnMap(item: any) {

    $('#stdLocation').modal('show');

    setTimeout(() => {

      if (this.map) this.map.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      var iconStyle = new Style({

        image: new Icon(({

          anchor: [0, 46],

          anchorXUnits: 'fraction',

          anchorYUnits: 'pixels',

          size: [48, 48],

          opacity: 1,

          src: '../../assets/Img/marker4.png'

        }))

      });


      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(

            new TileLayer({

              visible: false,

              preload: Infinity,

              source: new BingMaps({

                // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],

              }),

            }),

          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


      }

      this.map = new Map({

        layers: this.layers,

        target: 'map2',

        view: new View({

          center: olProj.fromLonLat([item.fOriginLon, item.fOrigiLat]),

          zoom: 13,

        }),

      });

    }, 500);

  }

  showAll() {

    $('#showAll').modal('show');

    setTimeout(() => {

      if (this.map2) this.map2.setTarget(null);

      var layers2 = [

        new Tile({

          source: new OSM()

        })

      ];

      this.map2 = new Map({

        target: "map1",

        view: new View({

          zoom: 4,

          center: olProj.fromLonLat([51.3833554, 35.6770113])

        }),

        layers: layers2

      });

      this.clustersLayer(this.list_Students);

    }, 500);

  }

  clustersLayer(data: any) {

    setTimeout(() => {

      this.map2.on('click', (e: any) => {

        if (e.dragging) return;

        var el = this.mapService.mapPointerMove(
          this.map2.getEventPixel(e.originalEvent),
          this.map2
        );

        if (el.featureLayer && el.featureLayer.feature.values_.features.length == 1) this.showDetail(el.featureLayer.feature.values_.features[0].values_.data)

        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.map2.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;


    let addFeatures = (nb: any) => {
      var ext = this.map2.getView().calculateExtent(this.map2.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([
            data[i].fOriginLon,
            data[i].fOrigiLat])

          ),
          id_: data[i].strUnitId,
          data: {
            iPassenger: data[i].iPassenger,
            strName: data[i].strName,
            strFamily: data[i].strFamily,
            strMobile: data[i].strMobile,
            strSex_strSexComment: data[i].strSex_strSexComment,
            strMobileDomain_strComment: data[i].strMobileDomain_strComment,
            fDistance: data[i].fDistance,
            strAddress: data[i].strAddress,
            fOrigiLat: data[i].fOrigiLat,
            fOriginLon: data[i].fOriginLon,
            strAvatar: data[i].strAvatar,
            strNationalCode: data[i].strNationalCode,

          },

        });

        features[i].set("id", i);
      }
      clusterSource.getSource().clear();

      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.map2.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.map2.addInteraction(selectCluster);


  }

  async showDetail(item: any) {

    this.isLoading = true;

    var model = this.OtherService.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iPassenger: item.iPassenger

    })

    let res = JSON.parse((await axios.post('School_Passenger_Info', model)).data.toString());

    this.isLoading = false;

    if (res.iResult == 0) return this.Notification.showError(res.strError)

    this.studentData = res[0];

    $('#detailModal').modal('show');


  }

  sortBy(input: any) {

    this.list_Students.sort((a: any, b: any) => {

      switch (input) {

        case 0:
          var textA = a.strFamily.toUpperCase();
          var textB = b.strFamily.toUpperCase();
          break;

        case 1:
          var textA = a.strMobileDomain_strComment && a.strMobileDomain_strComment.toUpperCase();
          var textB = b.strMobileDomain_strComment && b.strMobileDomain_strComment.toUpperCase();
          break;

        case 2:
          var textA = a.fDistance;
          var textB = b.fDistance;
          break;

        default:
          break;
      }

      if (textA > textB) return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;

      if (textA < textB) return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;

      return 0;
    })

  }

  setCheckBox(value: boolean, item: any) {

    if (value === true) this.lstPassenger.push(item.iPassenger);

    else {

      this.lstPassenger.find((value: any) => {

        if (value === item.iPassenger) {

          const index = this.lstPassenger.indexOf(item.iPassenger);

          if (index !== -1) this.lstPassenger.splice(index, 1);

        }

      })
    }

  }

  isSelected(item: any): boolean {

    return this.lstPassenger.indexOf(item) !== -1;
  }

  selectAllCheckBox() {

    if (this.list_Students.length > 0 && (this.list_Students.length != this.lstPassenger.length)) {

      this.lstPassenger = [];

      this.list_Students.forEach((a: any) => {

        this.lstPassenger.push(a.iPassenger);

      })

      this.Notification.showSuccess('همه کاربران انتخاب شدند')

    }

    else {

      this.lstPassenger = [];

    }

  }

  message_Modal() {

    if (this.lstPassenger.length == 0) return this.Notification.showError('لطفا دانش آموز مورد نظر خود را انتخاب کنید');

    $('#sendMessage').modal('show')
  }

  editStd(item: any) {

    this.std_PhoneNumber = item.strMobile

    $('#stdEdit').modal('show');

  }

  newPersonnel() {

    this.mdl_Search.patchValue({

      strMobile: ''

    })

    this.mdl_Personnel.patchValue({

      strName: '',

      strFamily: '',

      strMobile: '',

      strNationalCode: '',

      fOrigiLat: '',

      fOriginLon: '',

      strAddress: '',

      strChart: '',

      tiSex: -1,

      iMobileDomain: -1,

      iPassenger: '',

      bActive: false,

      itemIndex: -1,

      strExpireDate: '',

    })

    this.mdl_Personnel.disable();

    this.bEdit_Std = false;

    // Rerender custom-map

    this.showCustom_Map = false;

    setTimeout(() => {

      this.showCustom_Map = true;

    }, 10);

    // Rerender custom-filter

    this.showFilter = false;

    setTimeout(() => {

      this.showFilter = true;

    }, 10);

    $("#NewPersonnel").modal('show');

  }

  async getAddress() {

    var strAddress = document.getElementById('strAddress') as HTMLInputElement;

    if (strAddress.value != '') {

      let res = (await axios.post(`Geocoding`, { 'strAddress': strAddress.value }));

      if (res.data.fLat != 0 && res.data.fLon != 0) {

        this.baseLocation = [res.data.fLon, res.data.fLat];

        this.newOpenMap()
      }

      else this.newOpenMap()
    }

    else this.newOpenMap()

  }

  newOpenMap() {

    this.mdl_Personnel.get('fOrigiLat')?.setValue('');

    this.mdl_Personnel.get('fOriginLon')?.setValue('');

    $('#maplat').modal('show');

    setTimeout(() => {

      if (this.map) this.map.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      var iconStyle = new Style({

        image: new Icon(({

          anchor: [0, 46],

          anchorXUnits: 'fraction',

          anchorYUnits: 'pixels',

          size: [48, 48],

          opacity: 1,

          src: '../../assets/Img/marker4.png'

        }))

      });


      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(

            new TileLayer({

              visible: false,

              preload: Infinity,

              source: new BingMaps({

                // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],

              }),

            }),

          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


      }



      this.map = new Map({

        layers: this.layers,

        target: 'map',

        view: new View({

          center: olProj.fromLonLat(this.baseLocation),

          zoom: 16,

        }),

      });

      const marker = new Feature({

        geometry: new Point(olProj.fromLonLat(this.baseLocation)),

      });

      const vectorLayer = new VectorLayer({

        source: new VectorSource({

          features: [marker],

        }),

        style: new Style({

          image: new Icon({

            src: '../../assets/Img/marker4.png',

            scale: 1.0,

          }),

        }),

      });

      this.map.addLayer(vectorLayer);

      this.map.on('click', (e: any) => {

        this.map.removeLayer(vectorLayer)

        if (e.dragging) return;

        var coords = olProj.toLonLat(e.coordinate);

        this.mdl_Personnel.controls['fOrigiLat'].setValue(coords[1])

        this.mdl_Personnel.controls['fOriginLon'].setValue(coords[0])

        var iconGeometry = new Point(e.coordinate)

        var iconFeature = new Feature({

          geometry: iconGeometry,

        });

        iconFeature.setStyle(iconStyle);

        var vectorSource = new Vector({

          features: [iconFeature]

        });

        var dinamicPinLayer = new VectorLayer({

          source: vectorSource

        });

        this.map.getLayers().forEach((layer: VectorSource) => {

          if (layer?.getKeys().length < 11)

            this.map.removeLayer(layer);
        });

        this.map.addLayer(dinamicPinLayer);
      })

      this.map.on('pointermove', (e: any) => {

        var pixel = this.map.getEventPixel(e.originalEvent);

        var hit = this.map.hasFeatureAtPixel(pixel);

        this.map.getViewport().style.cursor = 'pointer';

      });

    }, 500);

  }

  async confirmLatol() {

    let model = {

      fLat: this.mdl_Personnel.controls['fOrigiLat'].value,

      fLon: this.mdl_Personnel.controls['fOriginLon'].value,

    }

    const address = await axios.post(`ReverseGeocoding`, model);

    this.mdl_Personnel.get('strAddress')?.setValue(address.data.strAddress)

    $('#maplat').modal('hide');

  }

  submitData(value: any) {

    // اگر کاربر متنی را به آدرس اضافه کرد

    if (value.isChanged == true) {

      this.mdl_Personnel.controls['strAddress'].setValue(value.strText);

    }

    // اگر کاربر از روی نقشه موقعیت را انتخاب کرد

    else {

      this.mdl_Personnel.controls['fOrigiLat'].setValue(value.latitude);

      this.mdl_Personnel.controls['fOriginLon'].setValue(value.longitude);

      this.mdl_Personnel.controls['strAddress'].setValue(value.strText_Toolbar);

      // Rerender custom-map

      this.showCustom_Map = false;

      setTimeout(() => {

        this.showCustom_Map = true;

      }, 10);

      // Rerender custom-filter

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

    }

  }

  async submit_NewPersonnel() {

    this.mdl_Personnel.get('strSTime')?.setValue($("#strSTime").val());

    this.mdl_Personnel.get('strETime')?.setValue($("#strETime").val());

    if (this.mdl_Personnel.invalid) return this.Notification.showError('لطفا فرم را با دقت تکمیل کنید');

    if (this.mdl_Personnel.get('strChart')?.value == '') return this.Notification.showError('جایگاه سازمانی را انتخاب کنید');

    if (this.mdl_Personnel.get('iMobileDomain')?.value == -1) return this.Notification.showError('حوزه خدمت را انتخاب کنید');

    if (this.mdl_Personnel.get('tiSex')?.value == -1) return this.Notification.showError('جنسیت را انتخاب کنید');

    else {

      if (!this.bEdit_Std) {

        this.isLoading = true;

        let res = JSON.parse((await axios.post(`Passenger_Save`, this.OtherService.stringNumberToNumber(this.mdl_Personnel.value))).data.toString());

        this.isLoading = false;

        if (res.iResult == 0) return this.Notification.showError(res.strError);

        this.list_Students.push(res[0]);

        $("#NewPersonnel").modal('hide');

        this.Notification.showSuccess('عملیات با موفقیت انجام شد')

      }

      else {

        $.confirm({

          title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

          content: '',

          type: 'blue',

          buttons: {

            ok: {

              text: "ویرایش",

              btnClass: 'btn-primary',

              keys: ['enter'],

              action: async () => {

                this.isLoading = true;

                let res = JSON.parse((await axios.post(`Passenger_Edit`, this.OtherService.stringNumberToNumber(this.mdl_Personnel.value))).data.toString());

                this.isLoading = false;

                if (res.iResult == 0) return this.Notification.showError(res.strError);

                this.list_Students[this.mdl_Personnel.get('itemIndex')?.value] = res[0];

                $("#NewPersonnel").modal('hide');

                this.Notification.showSuccess('عملیات با موفقیت انجام شد')

              }

            },

            cancel: {

              text: "لغو",

            }

          }

        });

      }

    }

  }

  editPersonnel(item: any, index: number) {

    this.bEdit_Std = true;

    this.mdl_Personnel.enable()

    this.mdl_Personnel.get('itemIndex')?.setValue(index)

    Object.keys(item).forEach(key => {

      this.mdl_Personnel.get(key)?.setValue(item[key])

    })

    // rerender custom-map

    this.showCustom_Map = false;

    setTimeout(() => {

      this.showCustom_Map = true;

    }, 10);

    // rerender custom-filter

    this.showFilter = false;

    setTimeout(() => {

      this.showFilter = true;

    }, 10);

    $("#NewPersonnel").modal('show');


  }

  closeEditModal() {

    this.bDataLoaded = false;

    this.std_PhoneNumber = undefined;

    $('#stdEdit').modal('hide');

  }

  editFinancial(item: any) {

    item.iDebit = item.iDebit.toLocaleString();

    item.iCredit = item.iCredit.toLocaleString();

    this.financialModel = item;

    this.date.controls['strDate'].setValue(item.strDate);

    this.editMode = true;

    this.bAddFinancial = true;
  }

  async sendMessage(form: NgForm) {

    if (form.value.strMessage == '') return this.Notification.showError('لطفا متن پیام را مشخص کنید');

    if (!form.value.bSendPush && !form.value.bSaveMessage) return this.Notification.showError('لطفا نحوه ارسال پیام را مشخص کنید');

    form.value['iSystemUser'] = this.gurdService.decrypt(localStorage.getItem('ID')!);

    form.value['strSession'] = this.gurdService.decrypt(localStorage.getItem('Session')!);

    form.value['lstPassenger'] = this.lstPassenger;

    let res = JSON.parse((await axios.post(`School_Passenger_SendMessage`, form.value)).data.toString());

    if (res.iResult) {

      $('#sendMessage').modal('hide');

      return this.Notification.showSuccess('پیام با موفقیت ارسال شد');
    }

    else return this.Notification.showError(res.strError)


  }

  async showHistory(item: any) {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iPassenger: item.iPassenger

    }

    let res = JSON.parse((await axios.post(`Passenger_LogStory_List`, model)).data.toString());

    this.userActivity = res;

    $("#userActive").modal('show')

  }

  async checkAbsence(item: any) {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iPassenger: item.iPassenger

    }

    let res = JSON.parse((await axios.post(`PresenceAbsence_StudentsList`, model)).data.toString());

    this.list_Absence = res;

    $("#userAbsence").modal('show')

  }

  async showFinancial(item: any) {

    this.isLoading = true;

    this.financialModel = {};

    this.financialModel.iPassenger = item.iPassenger;

    this.studentData = item;

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iPassenger: item.iPassenger

    }

    let res = JSON.parse((await axios.post(`School_DebitCredit_List`, model)).data.toString());

    this.isLoading = false;

    res.forEach((a: any) => {

      this.iTotalOwed += a.iDebit;

      this.iTotalCreditor += a.iCredit;

    })

    this.list_Finance = res;

    this.list_search2 = res;

    this.bAddFinancial = false;

    $("#stdFinancial").modal('show');


  }

  async saveFinancial_Report() {

    if (this.date.value.strDate == '') return this.Notification.showError('لطفا تاریخ را وارد کنید');

    if (!this.financialModel.iDebit && !this.financialModel.iCredit) return this.Notification.showError('لطفا مبلغ بدهکاری  یا پستانکاری را مشحص کنید');

    this.financialModel.strDate = this.date.value.strDate;

    this.financialModel.iDebit = this.financialModel.iDebit ? this.financialModel.iDebit.replace(/,/g, '') : 0;

    this.financialModel.iCredit = this.financialModel.iCredit ? this.financialModel.iCredit.replace(/,/g, '') : 0;

    this.financialModel.strComment = this.financialModel.strComment ? this.financialModel.strComment : '';

    this.financialModel.iSystemUser = this.gurdService.decrypt(localStorage.getItem('ID')!);

    this.financialModel.strSession = this.gurdService.decrypt(localStorage.getItem('Session')!);

    this.financialModel.iPassenger = this.studentData.iPassenger;

    if (this.financialModel.iCredit != 0 && this.financialModel.iCredit != '') {

      this.financialModel.iDebit = 0;

    }

    if (this.financialModel.iDebit != 0 && this.financialModel.iDebit != '') {

      this.financialModel.iCredit = 0;

    }

    if (!this.financialModel.bCheck) {

      this.financialModel.bCheck = false;

    }

    if (!this.editMode) {

      this.isLoading = true;

      let res: any = JSON.parse((await axios.post(`School_DebitCredit_Save`, this.OtherService.stringNumberToNumber(this.financialModel))).data.toString());

      this.isLoading = false;

      if (res.iResult == 0) return this.Notification.showError(res.strError)

      this.list_Finance.push(res[0]);

      this.Notification.showSuccess('با موفقیت اضافه شد');

      this.iTotalOwed = 0;

      this.iTotalCreditor = 0;

      this.list_Finance.forEach((a: any) => {

        this.iTotalOwed += a.iDebit;

        this.iTotalCreditor += a.iCredit;

      })


      this.financialModel = {};

      this.date.controls['strDate'].setValue('');

      this.bAddFinancial = false;



    }

    else {

      $.confirm({

        title: `آیا از ویرایش این گزارش اطمینان دارید ؟`,

        content: '',

        type: 'red',

        buttons: {

          ok: {

            text: "تایید",

            btnClass: 'btn-success',

            keys: ['enter'],

            action: async () => {

              this.isLoading = true;

              let res: any = JSON.parse((await axios.post(`School_DebitCredit_Edit`, this.OtherService.stringNumberToNumber(this.financialModel))).data.toString());

              this.Notification.showSuccess('با موفقیت ویرایش شد');

              const index = this.list_Finance.indexOf(this.financialModel);

              if (index != -1) this.list_Finance[index] = res[0];

              this.iTotalOwed = 0;

              this.iTotalCreditor = 0;

              this.list_Finance.forEach((a: any) => {

                this.iTotalOwed += a.iDebit;

                this.iTotalCreditor += a.iCredit;

              })

              this.isLoading = false;

              this.financialModel = {};

              this.date.controls['strDate'].setValue('');

              this.bAddFinancial = false;


            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

  async removeFinancial(item: any) {

    $.confirm({

      title: `آیا از حذف ( ${item.strComment} )  اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-success',

          keys: ['enter'],

          action: async () => {

            var model = {

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              iSchool_DebitCredit: item.iSchool_DebitCredit

            }

            let res = JSON.parse((await axios.post(`School_DebitCredit_Delete`, model)).data.toString());

            if (res.iResult == 1) {

              const Index = this.list_Finance.indexOf(item)

              if (Index != -1) this.list_Finance.splice(Index, 1);

              this.iTotalOwed = 0;

              this.iTotalCreditor = 0;

              this.list_Finance.forEach((a: any) => {

                this.iTotalOwed += a.iDebit;

                this.iTotalCreditor += a.iCredit;

              })

              this.Notification.showSuccess('با موفقیت حذف شد');


            }


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  async removePersonnel(item: any) {

    $.confirm({

      title: `آیا از حذف اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              iPassenger: item.iPassenger

            };

            this.isLoading = true;

            let res = JSON.parse((await axios.post(`Passenger_Delete`, model)).data.toString());

            this.isLoading = false;

            if (res.iResult == 0) return this.Notification.showError(res.strError);

            else {

              const index = this.list_Students.indexOf(item);

              if (index != -1) this.list_Students.splice(index, 1)

              this.Notification.showSuccess('عملیات با موفقیت انجام شد');

            }

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });



  }

  search_Finance(search: any) {

    if (search.length > 2) {

      this.list_Finance = this.list_search2.filter((el: any) => {

        return el.strDate.includes(search) || el.strComment.includes(search)

      })
    }

    else if (search == '') this.list_Finance = this.list_search2;

    this.iTotalOwed = 0;

    this.iTotalCreditor = 0;

    this.list_Finance.forEach((a: any) => {

      this.iTotalOwed += a.iDebit;

      this.iTotalCreditor += a.iCredit;

    })

  }

  private _filter(value: string): string[] {

    const filterValue = value

    return this.list_Schools.filter((option: { strComment: string | string[]; }) => option.strComment.includes(filterValue));

  }

  financial_Excel() {

    setTimeout(() => {

      let element = document.getElementById('financial_Excel');

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, 'گزارش مالی.xlsx');

    }, 200);


  }

  // 

  async personnelSearch() {

    if (this.mdl_Search.invalid) return this.Notification.showError('شماره موبایل را وارد کنید');

    else {

      this.OtherService.Showspinner();

      let res = JSON.parse((await axios.post(`School_Passenger_Search`, this.OtherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

      this.OtherService.nonespinner();

      if (res?.iResult == 0) return this.Notification.showError(res.strError);

      this.mdl_Personnel.enable();

      if (res[0]?.strName) {

        this.bEdit_Std = true;

        Object.keys(res[0]).forEach(key => {

          this.mdl_Personnel.get(key)?.setValue(res[0][key])

        })

      }

      else {

        this.bEdit_Std = false;

        this.mdl_Personnel.patchValue({

          strName: '',

          strFamily: '',

          strMobile: '',

          strNationalCode: '',

          fOrigiLat: '',

          fOriginLon: '',

          strAddress: '',

          strChart: '',

          tiSex: -1,

          iMobileDomain: -1,

          iPassenger: '',

          bActive: false,

          itemIndex: -1,

          strExpireDate: '',

        })

      }

      // Rerender custom-map

      this.showCustom_Map = false;

      setTimeout(() => {

        this.showCustom_Map = true;

      }, 10);

      // Rerender custom-filter

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);


    }

  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this.OtherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }

  setValue_Filter(event: any, type: 'iMobileDomain' | 'strChart') {

    if (type == 'iMobileDomain') {

      if (!event.iMobileDomain.toString()) {

        this.mdl_Personnel.controls['iMobileDomain'].setValue('')

      }

      else {

        this.mdl_Personnel.controls['iMobileDomain'].setValue(event.iMobileDomain);

      }

    }

    if (type == 'strChart') {

      if (!event.strChart) {

        this.mdl_Personnel.controls['strChart'].setValue('')

      }

      else {

        this.mdl_Personnel.controls['strChart'].setValue(event.strChart);

      }

    }

  }

  async viewItem(item) {

    this.OtherService.Showspinner();

    let res = JSON.parse((await axios.post(`School_DailyReports_Passenger`, this.OtherService.stringNumberToNumber({ ...this.mdl_Search.value, ...item }))).data.toString());

    this.OtherService.nonespinner();

    if (res?.ISSessionExpired == true) {

      this.Notification.showError('لطفا وارد سیستم شوید');

      this.OtherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x110' } });

      return;

    }

    if (res.iResult == 0) return this.Notification.showError(res.strError);

    if (!res.length) this.Notification.showError('نتیجه ایی یافت نشد')

    this.lst_Result = res;

    $("#viewModal").modal('show');

  }

  addReport(item) {

    this.mdl_ReportDaily.patchValue({

      strImage: '',

      strComment: '',

      iPassenger: item.iPassenger,

    })

    $("#addReportModal").modal('show');


  }

  onFileInput(file: any) {

    let extension = file.name.split('.').pop();

    if (extension !== 'jpeg' && extension !== 'jpg') this.Notification.showError(' فرمت قابل قبول فقط jpg است')

    if (extension === 'jpeg' || extension === 'jpg') {

      const reader: any = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = async () => {

        var base64String = reader.result.toString();

        this.mdl_ReportDaily.controls['strImage'].setValue(base64String.replace('data:image/jpeg;base64,', ''))

      };

    }


  }

  async submitReport_Daily() {

    if (this.mdl_ReportDaily.invalid) return this.Notification.showError('لطفا فرم را با دقت تکمیل کنید');

    this.OtherService.Showspinner();

    let res = JSON.parse((await axios.post(`School_DailyReports_Save`, this.OtherService.stringNumberToNumber(this.mdl_ReportDaily.value))).data.toString());

    this.OtherService.nonespinner();

    if (res?.ISSessionExpired == true) {

      this.Notification.showError('لطفا وارد سیستم شوید');

      this.OtherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x1x10' } });

      return;

    }

    if (res.iResult == 0) return this.Notification.showError(res.strError);

    this.Notification.showSuccess('با موفقیت ثبت شد.');

    this.lst_Result.push(res[0]);

    $("#addReportModal").modal('hide');


  }

  accessibility(...array: string[]): boolean {

    let result = false;

    for (let i = 0; i < array.length; i++) {

      if (this.acssess[array[i]] == true && !result) {

        result = true;

        break;

      }

    }

    return result;

  }

  highlightText(text: string, searchTerm: string) {

    if (!searchTerm) {

      return text;

    }

    const regex = new RegExp(searchTerm, 'gi');

    return text?.replace(regex, (match: string) => {

      return `<mark>${match}</mark>`;

    });

  }

  async viewItemInfo(item) {

    this.OtherService.Showspinner();

    let res = JSON.parse((await axios.post(`School_DailyReports_Info`, this.OtherService.stringNumberToNumber({ ...this.mdl_Search.value, ...item }))).data.toString());

    this.OtherService.nonespinner();

    if (res?.ISSessionExpired == true) {

      this.Notification.showError('لطفا وارد سیستم شوید');

      this.OtherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x11x0' } });

      return;

    }

    if (res.iResult == 0) return this.Notification.showError(res.strError);

    this.obj_Std = res[0];

    $("#viewModalInfo").modal('show')

  }

  fullScreen_Image() {

    if (!this.obj_Std.strImage) return;

    const image_Element = $("#fullScreen_");

    image_Element.toggleClass('full-screen');

  }

  removeItem(item, index) {

    $.confirm({

      title: `آیا از حذف اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this.OtherService.Showspinner()

            var model = {

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              iSchool_DailyReports: item.iSchool_DailyReports


            }

            let res = JSON.parse((await axios.post(`School_DailyReports_Delete`, this.OtherService.stringNumberToNumber(model))).data.toString());

            this.OtherService.nonespinner()

            if (res.iResult == 0) return this.Notification.showError(res.strError);

            else {

              this.lst_Result.splice(index, 1);

              this.Notification.showSuccess(' با موفقیت حذف شد');

            }


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });
  }

  async openCredit(item) {

    await this.getStudentCredit(item);

    await this.getStudent_CreditList(item);

    $("#creditModal").modal('show');

  }

  async getStudentCredit(item) {

    this.mdl_Search.patchValue({

      iPassenger: item.iPassenger

    })

    this.OtherService.Showspinner();

    let res = JSON.parse((await axios.post(`School_Credit_Info`, this.OtherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this.OtherService.nonespinner();

    if (res?.ISSessionExpired == true) {

      this.Notification.showError('لطفا وارد سیستم شوید');

      this.OtherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x11x0' } });

      return;

    }

    if (res.iResult == 0) {

      return this.Notification.showError(res.strError);

    }

    this.mdl_Charge.patchValue({

      iPassenger: item.iPassenger,

      current_iAmount: res[0]?.iAmount || 0,

      strPassenger_FullName: item.strFullName,

    })


  }

  async getStudent_CreditList(item) {

    this.mdl_Search.patchValue({

      iPassenger: item.iPassenger

    })

    this.OtherService.Showspinner();

    let res = JSON.parse((await axios.post(`School_ChargeAccount_List`, this.OtherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this.OtherService.nonespinner();

    if (res?.ISSessionExpired == true) {

      this.Notification.showError('لطفا وارد سیستم شوید');

      this.OtherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x11x0' } });

      return;

    }

    if (res.iResult == 0) {

      return this.Notification.showError(res.strError);

    }

    this.lst_Credit = res;

    this.iAmount = 0;

    this.lst_Credit.forEach((el) => {

      this.iAmount += el.iAmount;

    })


  }

  open_AddCredit() {

    this.mdl_Charge.patchValue({

      iAmount: '',

      strTrackingCode: '',

    });

    $("#addCreditModal").modal('show');


  }

  async submitCredit() {

    if (this.mdl_Charge.invalid) return this.Notification.showError('لطفا فرم را با دقت تکمیل کنید');

    this.OtherService.Showspinner();

    let res = JSON.parse((await axios.post(`School_ChargeAccount_Save`, this.OtherService.stringNumberToNumber(this.mdl_Charge.value))).data.toString());

    this.OtherService.nonespinner();

    if (res?.ISSessionExpired == true) {

      this.Notification.showError('لطفا وارد سیستم شوید');

      this.OtherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x1x10' } });

      return;

    }

    if (res.iResult == 0) return this.Notification.showError(res.strError);

    // console.log(res)

    this.lst_Credit.push(res[0]);

    this.iAmount = 0;

    this.lst_Credit.forEach((el) => {

      this.iAmount += el.iAmount;

    })


    $("#addCreditModal").modal('hide');

    this.Notification.showSuccess('با موفقیت ثبت شد.');


  }

}
